<template>
  <svg class="aContent" v-bind:id="aId" />
</template>
    
<script>
export default {
  name: "",
  data() {
    return {
      width: 240
    };
  },
  props: ["aId", "progress"],
  watch: {
    progress: function(newValue, oldValue) {
      var startAngle = (Math.PI * 5) / 4;
      var length = startAngle + (Math.PI * 1) / 4;
      var rValue = length * newValue;
      var endAngle = startAngle - rValue;

      //起始角度大于pi  画大弧  狠关键
      var big = 0
      if ((startAngle - endAngle) >= Math.PI) {
          big = 1
      }
    
      var color = "#2BCCFF"
      if(this.aId === 'svg1') {
          color = "#F9FB8F"
      } 
      var svg = document.getElementById(this.aId);
      var path1 = this.createSVGArcPath(
        this.width / 2,
        this.width / 2,
        this.width / 2 - 20,
        startAngle,
        endAngle,
        big,
        20,
        color
      );
      path1.setAttribute("stroke-dasharray", [10, 5]);
      svg.appendChild(path1);
    }
  },
  mounted() {
    var svg = document.getElementById(this.aId);
    var path = this.createSVGArcPath(
      this.width / 2,
      this.width / 2,
      this.width / 2 - 20,
      (Math.PI * 5) / 4,
      (-Math.PI * 1) / 4,
      1,
      20,
      "#304C6F"
    );
    svg.appendChild(path);
  },
  methods: {
    createSVGArcPath(
      centerX,
      cneterY,
      R,
      startAngle,
      endAngle,
      bigArc,
      arcWidth,
      color
    ) {
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      var startX = centerX + R * Math.cos(startAngle);
      var startY = cneterY - R * Math.sin(startAngle);
      var endX = centerX + R * Math.cos(endAngle);
      var endY = cneterY - R * Math.sin(endAngle);
      var dArr = ["M" + startX, startY, "A" + R, R, 0, bigArc, 1, endX, endY];
      var d = dArr.join(" ");
      path.setAttribute("d", d);
      path.setAttribute("stroke", color);
      path.setAttribute("stroke-width", arcWidth);

      path.setAttribute("fill", "none");
      return path;
    }
  }
};
</script>

<style scoped>
.aContent {
  height: 240px;
  width: 240px;
  display: flex;
  flex-direction: row;
}
</style>
